export default {
    name: 'manage-2fa',
    props: {
        userData: Object,
        manageTwoFactorAuth: Object,
        loadUserData: Function
    },
    data() {
        return {

            message: null,
            messageClass: null,
            messageTimer: null,
            phoneRegEx: /^\(?([0-9]{3})\)?([0-9]{3})\)?([0-9]{4})$/,
            //Rules
            phoneRules: [
                v => !!v || 'Cell Phone Number field is required',
                v => this.phoneRegEx.test(v) || 'Please enter a valid Cell Phone Number'
            ],
            codeRules: [
                v => !!v || 'Verification Code field is required',
            ],
            saving: false

        }
    },
    watch: {
        'manageTwoFactorAuth.enable2FAAuthentication': function (newValue) {
            // eslint-disable-next-line
            if (!!newValue) {
                this.phoneNumberVerificationCode = '';
            }
        },

        'manageTwoFactorAuth.phoneNumberVerificationCode': function () {
            if(this.saving) {
                this.$refs.authForm.resetValidation();
                this.saving = false;
            }
        }
    },
    computed: {
        phoneNumberValid() {
            return this.manageTwoFactorAuth.enable2FAAuthentication
                && this.manageTwoFactorAuth.phoneNumber !== null
                && this.phoneRegEx.test(this.manageTwoFactorAuth.phoneNumber)
        }
    },
    methods: {
        update2FAData() {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    PhoneNumber: self.manageTwoFactorAuth.phoneNumber,
                    VerificationCode: self.manageTwoFactorAuth.phoneNumberVerificationCode,
                    EnableTwoFactorSMSAuthentication: !!self.manageTwoFactorAuth.enable2FAAuthentication,
                };

            if (!self.$refs.authForm.validate()) {
                return;
            }

            self.$state.set("loading", true);
            self.saving = true;
            self.$api.manageAuth(self.userData, data, function (response) {
                let message = response.status != 200 &&
                    response.data ?
                    response.data.value : null;
                self.$state.set("loading", false);
                self.showMessage(message || 'Updating User Data failed.', 'error-message');
            }).then(function (responseData) {
                if (responseData) {
                    self.$state.set("loading", false);
                    self.loadUserData();
                }
            });
        },

        sendCode() {
            let self = this,
                data = {
                    PhoneNumber: self.manageTwoFactorAuth.phoneNumber
                };

            if (!self.phoneNumberValid) {
                return;
            }

            this.$state.set("loading", true);
            self.$api.sendCode(self.userData, data, function (response) {
                let message = response.status != 200 &&
                    response.data ?
                    response.data.value : null;
                self.$state.set("loading", false);
                self.showMessage(message || 'Verification Code sending failed', 'error-message');
            }).then(function (responseData) {
                if (responseData) {
                    self.$state.set("loading", false);
                }
            });
        },

        showMessage(message, messageClass) {
            let self = this;

            self.message = message;
            self.messageClass = messageClass;

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.clearMessage(messageClass);
            }, 3000);
        },

        clearMessage(messageClass) {
            let self = this;

            self.messageClass = messageClass + ' fade-out';

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.message = null;
                self.messageClass = null;
            }, 700);

        }
    }
}
